export default "__VITE_ASSET__CXfHSmiM__"